import { createCryptoTokenNice } from "api/api";
import { NiceProps } from "type/type";

export const onClickNicePass = async (niceProps: NiceProps) => {
	const form = document.getElementById('nice_form') as HTMLFormElement;

	// 위에서 언급했던 token api가 요청 데이터를 암호화한 후 표준창 호출에 필요한 데이터를 응답해준다.
	const res = await createCryptoTokenNice(niceProps);

	if (form && res.data) {
		const { enc_data, token_version_id, integrity_value } = res.data;

		if (!niceProps.viewtype) { 
			// 현재창으로 표준창 호출
			form.target = '_self';
		}
		else if (niceProps.viewtype === 'popup') {
			// 팝업으로 표준창 호출
			const option = `width=480, height=812, top=100, fullscreen=no, menubar=no, status=no, toolbar=no,titlebar=yes, location=no, scrollbar=no`;
			window.open('', 'nice_popup', option);	

			form.target = 'nice_popup';
		}

		form.enc_data.value = enc_data;
		form.token_version_id.value = token_version_id;
		form.integrity_value.value = integrity_value;
		form.submit();
	}
};

export function NiceUi() {
	// ?redirect_code=1 일 경우, 본인인증 성공
	const redirect_code = new URLSearchParams(window.location.search).get('redirect_code'); 
  return (
    <div style={{display:'flex', flexDirection: 'column', gap: '1rem'}}>
      <br /><h1>Nice 표준창 호출</h1><br />
			<form name="nice_form" id="nice_form" method="post" action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb">
        <input type="hidden" id="m" name="m" value="service" />
        <input type="hidden" id="token_version_id" name="token_version_id" value="" />
        <input type="hidden" id="enc_data" name="enc_data" value="" />
				<input type="hidden" id="integrity_value" name="integrity_value" value="" />
			</form>

			<button onClick={() => onClickNicePass({ type:'test', redirect_url:{success:'/test/nice?redirect_code=1',fail:'/test/nice?redirect_code=0'}, access_token: 'test', viewtype:'popup'})}>PASS 인증</button>
			
			<br />
			{/* 본인인증 성공일 경우, 해당 글자가 보인다. ?redirect_code=1 */}
			<h1>Nice 인증 결과가 아래에 표출됩니다.</h1>
			{redirect_code === '1' && <h1>Nice 인증 성공</h1>}
			{redirect_code === '0' && <h1>Nice 인증 실패</h1>}
			<br />
			
    </div>
  )
}